import { Component, Input } from '@angular/core';
import { ConfigService } from '../../../../services/config.service';
import { OrderService } from '../../../../services/order.service';
import { AuthorizationService } from '../../../../services/authorization.service';
import { ContactService } from '../../../../services/contact.service';
@Component({
  selector: 'app-cfd-form-account-info',
  templateUrl: './cfd-form-account-info.component.html',
  styleUrls: ['./cfd-form-account-info.component.css']
})

export class CfdFormAccountInfoComponent {

  private readonly _configService: ConfigService;
  private readonly _contactService: ContactService;
  @Input() enteredByUserRole : string | null = null;

  constructor(public orderService: OrderService, configService: ConfigService, contactService: ContactService, private authorizationService: AuthorizationService) {
    this._configService = configService;
    this._contactService = contactService;
  }

  generateFullName(firstName: string | null, lastName: string | null): string {
    return [firstName, lastName].filter(Boolean).join(' ');
  }
  
  generateBillToName(): string {
    if (this.orderService.orderDto.paymentMethod === 'S') {
      return this.generateFullName(this.orderService.orderDto.shipToDto?.firstName ?? null, this.orderService.orderDto.shipToDto?.lastName ?? null);
    }
    if(this.orderService.orderDto.billToDto.contactId !== null){
      let billToContact = this._contactService.contactDtos?.find(c => c.contactId === this.orderService.orderDto.billToDto.contactId);
      if(billToContact){
        return this.generateFullName(billToContact.firstName ?? null, billToContact.lastName ?? null);
      }
    }
    return this.generateFullName(this.orderService.orderDto.orderByDto?.firstName ?? null, this.orderService.orderDto.orderByDto?.lastName ?? null);
  }

  generateCityStateZipForBillTo(city: string | null, state: string | null | undefined, zip: string | null): string {
    if(this.orderService.orderDto?.paymentMethod === 'S'){
      zip = this.orderService?.selectedShipToContact?.mailingStreet ? this.orderService.selectedShipToContact?.mailingZip
        : this.orderService?.selectedShipToContact?.street ? this.orderService.selectedShipToContact?.zip
          : this.orderService.orderDto?.shipToDto?.zip;
      state = this.orderService?.selectedShipToContact?.mailingStreet ? this.orderService?.selectedShipToContact?.mailingState
        : this.orderService?.selectedShipToContact?.street ? this.orderService?.selectedShipToContact?.state
          : this.orderService.orderDto?.shipToDto?.state;
      city = this.getCityDetailsForBillTo();
    }

    return [[city, state].filter(Boolean).join(', '), zip].filter(Boolean).join(' ');
  }

  getCityDetailsForBillTo(){
    return this.orderService?.selectedShipToContact?.mailingStreet ? this.orderService.selectedShipToContact?.mailingCity
      : this.orderService?.selectedShipToContact?.street ? this.orderService.selectedShipToContact?.city
        : this.orderService.orderDto?.shipToDto?.city;
  }
  generateCityStateZipForShipTo(city: string | null, state: string | null | undefined, zip: string | null): string {
    if(this.orderService.orderDto?.paymentMethod === 'S'){
      zip = this.orderService?.selectedShipToContact?.street ? this.orderService.selectedShipToContact?.zip
        : this.orderService?.selectedShipToContact?.mailingStreet ? this.orderService.selectedShipToContact?.mailingZip
        : this.orderService.orderDto.billToDto?.street ? this.orderService.orderDto.billToDto?.zip
        : this.orderService.orderDto?.shipToDto?.zip;
      state = this.orderService?.selectedShipToContact?.street ? this.orderService?.selectedShipToContact?.state
        : this.orderService?.selectedShipToContact?.mailingStreet ? this.orderService?.selectedShipToContact?.mailingState
        : this.orderService.orderDto.billToDto?.street ? this.orderService.orderDto.billToDto?.state
        : this.orderService.orderDto?.shipToDto?.state;
      city = this.getCityDetailsForShipTo();
    }

    return [[city, state].filter(Boolean).join(', '), zip].filter(Boolean).join(' ');
  }
  getCityDetailsForShipTo(){
    return this.orderService?.selectedShipToContact?.street ? this.orderService?.selectedShipToContact?.city
        : this.orderService?.selectedShipToContact?.mailingStreet ? this.orderService?.selectedShipToContact?.mailingCity
        : this.orderService.orderDto.billToDto?.street ? this.orderService.orderDto.billToDto?.city
        : this.orderService.orderDto?.shipToDto?.city;
  }
  getClientManagerName(): string {
    if (this.orderService.orderDto.salesOrganization === 'Shutterfly') {
      if (this.orderService.orderDto.billToDto.accountTypeCode === 'O') {
        return this._configService.hasResource('OverrideSmallAccountClientManagerName') ? "Melissa Werth" : this._configService.user.fullName;
      }
      else if(!this.orderService.orderDto.billToDto.printRepCode){
        return this.orderService.orderDto.billToDto.accountTypeCode === 'H'? this._configService.getFullNameFromUserCode(this.orderService.orderDto.billToDto.accountOwnerCode):'';
      }   
      else{
        return this._configService.getFullNameFromUserCode(this.orderService.orderDto.billToDto.printRepCode);
      }
    }
    return this._configService.getFullNameFromUserCode(this.orderService.orderDto.billToDto.accountOwnerCode);
  }
}